import { render, staticRenderFns } from "./ModalCancelAppointmentReason.vue?vue&type=template&id=d53fcbb4&"
import script from "./ModalCancelAppointmentReason.vue?vue&type=script&lang=js&"
export * from "./ModalCancelAppointmentReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports